import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import { useContext } from 'react';
import { LanguageContext } from '@/providers/LanguageContextProvider';
import { Card } from '@/components/ui/card';
import {
  Field,
  FieldContent,
  FieldError,
  FieldLabel,
} from '@/components/ui/field';
import { Checkbox } from '@/components/ui/checkbox';
import i18n from '@/utils/i18n';
import {
  CONFIRMATION_CHECKBOX_IDS,
  useOrderFormContext,
} from '../OrderFormContext';

export function TermsAndConditions() {
  const { termsAndConditionsCheckbox, confirmationErrors, setConfirmation } =
    useOrderFormContext();

  // i18n.t() subscribes to nothing, so the React Compiler may freeze these
  // strings at first mount - and the first mount runs before
  // LanguageContextProvider has called changeLanguage. The context locale is
  // already correct in that first render, so resolve against it explicitly.
  const { locale } = useContext(LanguageContext);
  const t = (key: string) => i18n.t(key, { lng: locale });

  const id = CONFIRMATION_CHECKBOX_IDS.termsAndConditions;
  const hasError = confirmationErrors.termsAndConditions;

  return (
    <Card className="tw:p-4 tw:gap-1">
      <h4 className="tw:text-xl tw:font-semibold">
        {t('EventOrder:termsAndConditionsTitle')}
      </h4>
      <Accordion type="single" collapsible className="tw:w-full">
        <AccordionItem value="item-1">
          <AccordionTrigger className="tw:py-5 tw:text-sm tw:font-medium">
            {t('EventOrder:termsSection1Title')}
          </AccordionTrigger>
          <AccordionContent className="tw:text-sm">
            {t('EventOrder:termsSection1Content')}
          </AccordionContent>
        </AccordionItem>

        <AccordionItem value="item-2">
          <AccordionTrigger className="tw:py-5 tw:text-sm tw:font-medium">
            {t('EventOrder:termsSection2Title')}
          </AccordionTrigger>
          <AccordionContent className="tw:text-sm">
            {t('EventOrder:termsSection2Content')}
          </AccordionContent>
        </AccordionItem>

        <AccordionItem value="item-3">
          <AccordionTrigger className="tw:py-5 tw:text-sm tw:font-medium">
            {t('EventOrder:termsSection3Title')}
          </AccordionTrigger>
          <AccordionContent className="tw:text-sm">
            {t('EventOrder:termsSection3Content')}
          </AccordionContent>
        </AccordionItem>

        <AccordionItem value="item-4">
          <AccordionTrigger className="tw:py-5 tw:text-sm tw:font-medium">
            {t('EventOrder:termsSection4Title')}
          </AccordionTrigger>
          <AccordionContent className="tw:text-sm">
            {t('EventOrder:termsSection4Content')}
          </AccordionContent>
        </AccordionItem>

        <AccordionItem value="item-5">
          <AccordionTrigger className="tw:py-5 tw:text-sm tw:font-medium">
            {t('EventOrder:termsSection5Title')}
          </AccordionTrigger>
          <AccordionContent className="tw:text-sm">
            {t('EventOrder:termsSection5Content')}
          </AccordionContent>
        </AccordionItem>
      </Accordion>
      <Field
        orientation="horizontal"
        data-invalid={hasError || undefined}
        className="tw:pt-4"
      >
        <Checkbox
          id={id}
          checked={termsAndConditionsCheckbox.termsAndConditions}
          onCheckedChange={(checked) =>
            setConfirmation('termsAndConditions', !!checked)
          }
          aria-required
          aria-invalid={hasError || undefined}
          className="tw:size-6 tw:border-muted-foreground tw:dark:aria-invalid:border-destructive tw:data-[state=checked]:bg-success-main tw:dark:data-[state=checked]:bg-success-main tw:data-[state=checked]:border-success-main tw:data-[state=checked]:text-white"
        />
        <FieldContent>
          <FieldLabel htmlFor={id}>
            {t('EventOrder:acceptGeneralTerms')}
          </FieldLabel>
          {hasError && (
            <FieldError>{t('EventOrder:confirmationRequired')}</FieldError>
          )}
        </FieldContent>
      </Field>
    </Card>
  );
}
